import React from 'react';
import { IStorefrontSettings } from '../../../../models/Storefront';
import { Callout } from '@fluentui/react';
import ImageEditor from '../../../Inputs/ImageEditor';

interface IStorefrontHeaderLogoEditorProps {
    storefrontSettings: IStorefrontSettings;
    onStorefrontSettingsChange: (newSettings: IStorefrontSettings) => void;
    editMode?: boolean;
    // Merchant styling for the logo <img> (headerConfig.logo), mirrored from the live storefront.
    logoStyle?: React.CSSProperties;
}

const StorefrontHeaderLogoEditor: React.FC<IStorefrontHeaderLogoEditorProps> = (props) => {
    const targetRef = React.useRef<HTMLDivElement>(null);
    const [calloutOpen, setCalloutOpen] = React.useState(false);

    if (!props.editMode && !props.storefrontSettings.headerLogo) {
        return null;
    }
    if (!props.editMode) {
        return <img src={props.storefrontSettings.headerLogo} className='storefront-header-logo' alt='Storefront Header Logo' style={props.logoStyle} />
    }

    const onClick = () => {
        setCalloutOpen(true);
    }

    return <div>
        <div className='storefront-header-logo-container-edit' ref={targetRef} onClick={onClick}>
            {props.storefrontSettings.headerLogo && <img src={props.storefrontSettings.headerLogo} className='storefront-header-logo' alt='Storefront Header Logo' style={props.logoStyle} />}
            {!props.storefrontSettings.headerLogo && <div className='storefront-header-logo-placeholder'></div>}
        </div>
        {calloutOpen && <Callout
            target={targetRef.current}
            onDismiss={() => setCalloutOpen(false)}
            style={{padding: '1em'}}
        >
            <h3>Header Logo Settings</h3>
            <ImageEditor
                label={'Header Logo'}
                value={props.storefrontSettings.headerLogo}
                onChange={(v) => props.onStorefrontSettingsChange({...props.storefrontSettings, headerLogo: v})}
                height={75}
                width={150}
                imageId={props.storefrontSettings.id}
                onClear={() => props.onStorefrontSettingsChange({...props.storefrontSettings, headerLogo: ''})}
                imageType='Storefront'
            />
        </Callout>}
    </div>
}

export default StorefrontHeaderLogoEditor;
